import differenceInUtcDays from "./difference-in-utc-days";
import resolveStartOfDay from "./resolve-start-of-day";
import subUtcDays from "./sub-utc-days";

export default function selectMinimalDate(
  first?: Date, 
  last?: Date, 
  range: number = 7,
  options?: {
    timezone?: string;
    withoutDateDifference?: boolean;
  }
) {
  if (!first) {
    return undefined;
  }

  const firstDate = resolveStartOfDay(first, options);
  const currentDate = resolveStartOfDay(new Date(), options);
  const currentDaysDiff = differenceInUtcDays(currentDate, firstDate);

  let daysOffset = currentDaysDiff % range;
  if (last) {
    const lastDate = resolveStartOfDay(last, options);
    const lastDaysDiff = differenceInUtcDays(lastDate, firstDate);
    const accessible = currentDaysDiff - lastDaysDiff > daysOffset;
    daysOffset -= accessible ? 0 : range;
  }

  return subUtcDays(currentDate, daysOffset);
}
